import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  Close as CloseIcon,
  CalendarToday,
  Star,
  Person,
  Sort,
  CloudUpload,
  Assessment,
  MonetizationOn,
  Download
} from '@mui/icons-material';
import { releaseNotice } from '../../data/releaseNotice';

const ReleaseNoticeModal = ({ open, onClose }) => {
  const handleClose = () => {
    // Save today's date to localStorage when closing
    const today = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD format based on local time
    localStorage.setItem('policytrackr_notice_shown_date', today);
    onClose();
  };

  // Function to get the appropriate emoji icon for each summary item
  const getSummaryIcon = (item) => {
    const lowerItem = item.toLowerCase();
    if (lowerItem.includes('report') || lowerItem.includes('metrics')) {
      return <Assessment sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    if (lowerItem.includes('discounted amount') || lowerItem.includes('amount')) {
      return <MonetizationOn sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    if (lowerItem.includes('referral option')) {
      return <PersonAdd sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    if (lowerItem.includes('Client')) {
      return <FilterAlt sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    if (lowerItem.includes('policies page')) {
      return <FilterList sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    if (lowerItem.includes('balance page')) {
      return <Sort sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    if (lowerItem.includes('documents')) {
      return <Sort sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    if (lowerItem.includes('export')) {
      return <Download sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    if (lowerItem.includes('import') || lowerItem.includes('upload')) {
      return <CloudUpload sx={{ color: 'primary.main', fontSize: 24 }} />;
    }
    // Default fallback
    return <Star sx={{ color: 'primary.main', fontSize: 24 }} />;
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 2,
          // responsive width for mobile
          width: { xs: '92%', sm: '600px', md: '720px' },
          boxSizing: 'border-box'
        }
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pb: 0,
        gap: 1,
        flexWrap: 'wrap',
        minWidth: 0,
        px: 2
      }}>
        <Typography
          variant="h4"
          component="div"
          sx={{
            fontFamily: 'Roboto Slab, serif',
            fontWeight: 600,
            fontSize: { xs: '18px !important', sm: '26px !important' },
            lineHeight: { xs: '28px !important', sm: '30px !important' },
            letterSpacing: '0.02em',
            color: 'primary.main',
            width: 'auto',
            whiteSpace: 'normal',
            display: 'block',
            gap: '4px',
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {releaseNotice.title}

        </Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          size="small"
          sx={{ flexShrink: 0 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 0.5, mt: 0.5, px: 2 }}>
        {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2, pl: 0 }}>
          version: {releaseNotice.version || 'v1.4'}
        </Typography> */}

        {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2, pl: 0 }}>
          here’s a quick look at what’s new in this update
        </Typography> */}

        <List dense sx={{ pl: 0 }}>
          {releaseNotice.summary.map((item, index) => (
            <ListItem key={index} sx={{ py: 0.25, alignItems: 'flex-start', pl: 0 }}>
              <ListItemIcon sx={{ minWidth: 28, alignSelf: 'flex-start', mt: 0.4 }}>
                {getSummaryIcon(item)}
              </ListItemIcon>
              <ListItemText
                primary={item}
                sx={{ mr: 0 }}
                primaryTypographyProps={{
                  variant: 'body2',
                  fontSize: '0.875rem'
                }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions
        sx={{
          pt: 1,
          pb: 1,
          px: { xs: 1, sm: 0 },
          justifyContent: { xs: 'center', sm: 'flex-end' }
        }}
      >
        <Button
          onClick={handleClose}
          variant="contained"
          fullWidth={false}
          sx={{
            width: { xs: '100%', sm: '110px' },
            height: '44px',
            borderRadius: '8px',
            px: 2,
            textTransform: 'none',
            backgroundColor: 'primary.main',
            color: '#FFFFFF',
            fontFamily: 'Roboto',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '24px',
            letterSpacing: '0.01em',
            opacity: 1,
            gap: '4px'
          }}
        >
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReleaseNoticeModal;
